export default {"src":"/_next/static/media/banner.fbc8ba5c.svg","height":2550,"width":2550,"blurWidth":0,"blurHeight":0};